import { render } from "./bmadd.vue?vue&type=template&id=2665a49b&scoped=true"
import script from "./bmadd.vue?vue&type=script&lang=js"
export * from "./bmadd.vue?vue&type=script&lang=js"

import "./bmadd.vue?vue&type=style&index=0&id=2665a49b&lang=scss&scoped=true"
import "./bmadd.vue?vue&type=style&index=1&id=2665a49b&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2665a49b"]])

export default __exports__